/**
 * Translations for store redirect / coming-soon pages.
 * Used by /huawei, /google and /ios routes.
 * Supported languages: en, ar, ur, zh, fa, tr, fr, bn, id
 */

const STORE_STRINGS = {
  en: {
    redirecting: 'Redirecting to AppGallery…',
    openManually: 'If nothing happens, tap the button below.',
    openHuawei: 'Open in AppGallery',
    googleTitle: 'Coming soon on Google Play',
    googleBody:
      'Falak is currently in closed testing on Google Play. We are gathering our first testers to unlock the production release.',
    googleWhy:
      'Google requires a 14-day closed test with at least 12 testers before a new developer can publish to production.',
    googleCTA: 'Meanwhile, install Falak from Huawei AppGallery — fully released and free.',
    iosTitle: 'Coming soon on iOS',
    iosBody:
      'A native iOS version of Falak is on our roadmap. Until then, the app is fully available on Huawei AppGallery and Google Play.',
    backHome: '← Back to Falak',
    huaweiCTA: 'Available now on Huawei AppGallery',
    installHuawei: 'Install from Huawei',
  },
  ar: {
    redirecting: 'جارٍ التحويل إلى متجر هواوي…',
    openManually: 'إن لم ينتقل الرابط تلقائياً، اضغط الزر أدناه.',
    openHuawei: 'فتح متجر هواوي',
    googleTitle: 'قريباً على متجر Google Play',
    googleBody:
      'تطبيق فلك حالياً في مرحلة الاختبار المغلق على Google Play. نجمع أوّل مختبرينا لفتح مرحلة الإصدار العام.',
    googleWhy:
      'يشترط جوجل مرحلة اختبار مغلق لمدة 14 يوماً مع 12 مختبراً على الأقل قبل السماح للمطور الجديد بالنشر العام.',
    googleCTA: 'في هذه الأثناء، ثبّت فلك من متجر هواوي — متاح مجاناً بالكامل.',
    iosTitle: 'قريباً على متجر App Store',
    iosBody:
      'نسخة iOS الأصلية من فلك ضمن خارطة طريقنا. في الوقت الحالي، التطبيق متوفر بالكامل على متجر هواوي وGoogle Play.',
    backHome: '→ العودة إلى فلك',
    huaweiCTA: 'متاح الآن على متجر هواوي',
    installHuawei: 'تحميل من هواوي',
  },
  ur: {
    redirecting: 'AppGallery پر منتقل ہو رہا ہے…',
    openManually: 'اگر خودکار طور پر منتقل نہ ہو، نیچے کا بٹن دبائیں۔',
    openHuawei: 'AppGallery میں کھولیں',
    googleTitle: 'جلد ہی Google Play پر',
    googleBody:
      'فلک اس وقت Google Play پر بند ٹیسٹنگ میں ہے۔ ہم پروڈکشن ریلیز کھولنے کے لیے پہلے ٹیسٹرز جمع کر رہے ہیں۔',
    googleWhy:
      'گوگل نئے ڈویلپر کے پروڈکشن ریلیز سے پہلے 12 ٹیسٹرز کے ساتھ 14 دن کا بند ٹیسٹ لازمی قرار دیتا ہے۔',
    googleCTA: 'اس دوران، فلک کو Huawei AppGallery سے مفت انسٹال کریں۔',
    iosTitle: 'جلد ہی iOS پر',
    iosBody:
      'فلک کا مقامی iOS ورژن ہمارے روڈ میپ میں ہے۔ فی الحال ایپ Huawei AppGallery اور Google Play پر مکمل طور پر دستیاب ہے۔',
    backHome: '→ فلک پر واپس جائیں',
    huaweiCTA: 'اب Huawei AppGallery پر دستیاب',
    installHuawei: 'Huawei سے انسٹال کریں',
  },
  zh: {
    redirecting: '正在跳转到 华为应用市场…',
    openManually: '若未自动跳转，请点击下方按钮。',
    openHuawei: '在 AppGallery 中打开',
    googleTitle: '即将登陆 Google Play',
    googleBody:
      'Falak 目前处于 Google Play 的封闭测试阶段。我们正在招募首批测试者以开启正式版本发布。',
    googleWhy:
      '根据 Google 政策，新开发者必须完成为期 14 天、至少 12 名测试者参与的封闭测试，才能发布正式版。',
    googleCTA: '与此同时,请从 华为 AppGallery 免费下载 Falak.',
    iosTitle: '即将登陆 iOS 应用商店',
    iosBody:
      'Falak 的原生 iOS 版本已列入开发计划。目前应用可在 华为 AppGallery 与 Google Play 上完整使用。',
    backHome: '← 返回 Falak',
    huaweiCTA: '现已上架 华为 AppGallery',
    installHuawei: '从华为下载',
  },
  fa: {
    redirecting: 'در حال هدایت به AppGallery…',
    openManually: 'اگر به‌طور خودکار انتقال نیافت، دکمه‌ی زیر را بزنید.',
    openHuawei: 'باز کردن در AppGallery',
    googleTitle: 'به‌زودی در Google Play',
    googleBody:
      'فلک اکنون در مرحله‌ی آزمایش بسته در Google Play قرار دارد. ما در حال جمع‌آوری اولین آزمایش‌گران هستیم تا انتشار عمومی فعال شود.',
    googleWhy:
      'گوگل برای انتشار عمومی توسط توسعه‌دهنده‌ی جدید، یک دوره‌ی آزمایش بسته ۱۴ روزه با حداقل ۱۲ آزمایش‌گر را الزامی می‌داند.',
    googleCTA: 'در این میان، فلک را رایگان از Huawei AppGallery نصب کنید.',
    iosTitle: 'به‌زودی در App Store',
    iosBody:
      'نسخه‌ی بومی iOS برنامه‌ی فلک در نقشه‌ی راه ما قرار دارد. در حال حاضر برنامه به‌طور کامل روی Huawei AppGallery و Google Play در دسترس است.',
    backHome: '→ بازگشت به فلک',
    huaweiCTA: 'اکنون در Huawei AppGallery در دسترس است',
    installHuawei: 'نصب از Huawei',
  },
  tr: {
    redirecting: 'AppGallery\'ye yönlendiriliyor…',
    openManually: 'Otomatik yönlendirilmediyseniz aşağıdaki düğmeye dokunun.',
    openHuawei: 'AppGallery\'de Aç',
    googleTitle: 'Google Play\'de yakında',
    googleBody:
      'Falak şu anda Google Play\'de kapalı test aşamasındadır. Genel yayın kilidini açmak için ilk test kullanıcılarımızı topluyoruz.',
    googleWhy:
      'Google, yeni bir geliştiricinin canlıya çıkabilmesi için en az 12 test kullanıcısıyla 14 günlük bir kapalı test şartı koşar.',
    googleCTA: 'Bu arada Falak\'ı Huawei AppGallery\'den ücretsiz yükleyebilirsiniz.',
    iosTitle: 'iOS\'ta yakında',
    iosBody:
      'Falak\'ın yerel iOS sürümü yol haritamızda yer alıyor. Şu anda uygulama Huawei AppGallery ve Google Play\'de tamamen kullanılabilir.',
    backHome: '← Falak\'a Dön',
    huaweiCTA: 'Huawei AppGallery\'de şimdi mevcut',
    installHuawei: 'Huawei\'den Yükle',
  },
  fr: {
    redirecting: 'Redirection vers AppGallery…',
    openManually: 'Si rien ne se passe, touchez le bouton ci-dessous.',
    openHuawei: 'Ouvrir dans AppGallery',
    googleTitle: 'Bientôt sur Google Play',
    googleBody:
      'Falak est actuellement en phase de test fermé sur Google Play. Nous rassemblons nos premiers testeurs pour débloquer la mise en production.',
    googleWhy:
      'Google exige un test fermé de 14 jours avec au moins 12 testeurs avant qu\'un nouveau développeur puisse publier en production.',
    googleCTA: 'En attendant, installez Falak depuis Huawei AppGallery — entièrement disponible et gratuit.',
    iosTitle: 'Bientôt sur iOS',
    iosBody:
      'Une version iOS native de Falak figure sur notre feuille de route. En attendant, l\'application est entièrement disponible sur Huawei AppGallery et Google Play.',
    backHome: '← Retour à Falak',
    huaweiCTA: 'Disponible dès maintenant sur Huawei AppGallery',
    installHuawei: 'Installer depuis Huawei',
  },
  bn: {
    redirecting: 'AppGallery-এ পুনঃনির্দেশিত হচ্ছে…',
    openManually: 'যদি স্বয়ংক্রিয়ভাবে না হয়, নিচের বোতামে চাপুন।',
    openHuawei: 'AppGallery-এ খুলুন',
    googleTitle: 'শীঘ্রই Google Play-তে',
    googleBody:
      'Falak বর্তমানে Google Play-তে ক্লোজড টেস্টিং পর্যায়ে রয়েছে। প্রোডাকশন রিলিজ চালু করতে আমরা প্রথম টেস্টার সংগ্রহ করছি।',
    googleWhy:
      'নতুন ডেভেলপারকে প্রোডাকশনে প্রকাশ করার আগে Google কমপক্ষে ১২ জন টেস্টার সহ ১৪ দিনের ক্লোজড টেস্ট বাধ্যতামূলক করে।',
    googleCTA: 'এদিকে, Huawei AppGallery থেকে Falak বিনামূল্যে ইনস্টল করুন।',
    iosTitle: 'শীঘ্রই iOS-এ',
    iosBody:
      'Falak-এর একটি নেটিভ iOS সংস্করণ আমাদের রোডম্যাপে রয়েছে। ততক্ষণ পর্যন্ত অ্যাপটি Huawei AppGallery এবং Google Play-তে সম্পূর্ণ উপলব্ধ।',
    backHome: '← Falak-এ ফিরে যান',
    huaweiCTA: 'এখন Huawei AppGallery-তে উপলব্ধ',
    installHuawei: 'Huawei থেকে ইনস্টল',
  },
  id: {
    redirecting: 'Mengalihkan ke AppGallery…',
    openManually: 'Jika tidak dialihkan otomatis, ketuk tombol di bawah.',
    openHuawei: 'Buka di AppGallery',
    googleTitle: 'Segera hadir di Google Play',
    googleBody:
      'Falak saat ini dalam tahap closed testing di Google Play. Kami sedang mengumpulkan penguji pertama untuk membuka rilis produksi.',
    googleWhy:
      'Google mensyaratkan pengujian tertutup selama 14 hari dengan minimal 12 penguji sebelum developer baru dapat merilis ke produksi.',
    googleCTA: 'Sementara itu, pasang Falak dari Huawei AppGallery — gratis dan sudah rilis penuh.',
    iosTitle: 'Segera hadir di iOS',
    iosBody:
      'Versi iOS asli Falak sudah masuk peta jalan kami. Sementara ini, aplikasi tersedia lengkap di Huawei AppGallery dan Google Play.',
    backHome: '← Kembali ke Falak',
    huaweiCTA: 'Tersedia sekarang di Huawei AppGallery',
    installHuawei: 'Pasang dari Huawei',
  },
};

export const HUAWEI_URL = 'https://appgallery.huawei.com/app/C118150847';
export const GOOGLE_PLAY_URL = 'https://play.google.com/store/apps/details?id=host.emergent.daylight_sync.twa';

/*
 * Google-Play-specific redirect strings, kept in a separate dict so we
 * don't have to touch the (already stable) Huawei/iOS strings above.
 * Only the two short strings needed by the redirect page — everything
 * else (openManually, back-home CTA, etc.) is generic enough to be
 * reused from getStoreStrings.
 */
const GOOGLE_STRINGS = {
  en: { redirecting: 'Redirecting to Google Play…', openStore: 'Open in Google Play' },
  ar: { redirecting: 'جارٍ التحويل إلى Google Play…', openStore: 'فتح في Google Play' },
  ur: { redirecting: 'Google Play پر منتقل ہو رہا ہے…', openStore: 'Google Play میں کھولیں' },
  zh: { redirecting: '正在跳转到 Google Play…', openStore: '在 Google Play 中打开' },
  fa: { redirecting: 'در حال هدایت به Google Play…', openStore: 'باز کردن در Google Play' },
  tr: { redirecting: 'Google Play\'e yönlendiriliyor…', openStore: 'Google Play\'de Aç' },
  fr: { redirecting: 'Redirection vers Google Play…', openStore: 'Ouvrir dans Google Play' },
  bn: { redirecting: 'Google Play-এ পুনঃনির্দেশিত হচ্ছে…', openStore: 'Google Play-এ খুলুন' },
  id: { redirecting: 'Mengalihkan ke Google Play…', openStore: 'Buka di Google Play' },
  es: { redirecting: 'Redirigiendo a Google Play…', openStore: 'Abrir en Google Play' },
  pt: { redirecting: 'Redirecionando para Google Play…', openStore: 'Abrir no Google Play' },
};

export function getStoreStrings(lang) {
  return STORE_STRINGS[lang] || STORE_STRINGS.en;
}

export function getGooglePlayStrings(lang) {
  return GOOGLE_STRINGS[lang] || GOOGLE_STRINGS.en;
}
